import React, { useEffect } from "react";
import "./potree.css";

function PotreePointcloudShared({ metadataUrl }) {
  const COMPASS_ROSE_SVG_DATA_URL = (() => {
    const svg =
      `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">` +
      `<circle cx="12" cy="12" r="9" />` +
      `<path d="M12 3 L14.2 10.0 L21 12 L14.2 14.0 L12 21 L9.8 14.0 L3 12 L9.8 10.0 Z" />` +
      `<path d="M12 8.2 L13.2 12 L12 15.8 L10.8 12 Z" />` +
      `</svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  })();

  const TRASH_SVG_DATA_URL = (() => {
    const svg =
      `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">` +
      `<polyline points="3 6 5 6 21 6" />` +
      `<path d="M19 6l-1 14H6L5 6" />` +
      `<path d="M10 11v6" />` +
      `<path d="M14 11v6" />` +
      `<path d="M9 6V4h6v2" />` +
      `</svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  })();

  const normalizeToolText = text =>
    String(text || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  useEffect(() => {
    const viewer = new window.Potree.Viewer(
      document.getElementById("potree_render_area")
    );

    viewer.setEDLEnabled(false);
    viewer.setFOV(60);
    viewer.setPointBudget(1_000_000);
    viewer.loadSettingsFromURL();
    viewer.setBackground("skybox");
    viewer.loadGUI(() => {
      viewer.setLanguage("br");
      window
        .$("#menu_tools")
        .next()
        .show();
      window
        .$("#menu_clipping")
        .next()
        .show();
      viewer.toggleSidebar();

      // Igual ao PotreePointcloud: adiciona tooltip onde o Potree não entrega `img.title`.
      requestAnimationFrame(() => {
        const icons = Array.from(document.querySelectorAll("#tools img.button-icon"));

        const getTooltip = img => {
          const closestLi = img?.closest?.("li");
          return (
            img?.title ||
            img?.getAttribute?.("aria-label") ||
            img?.getAttribute?.("data-tooltip") ||
            img?.parentElement?.title ||
            closestLi?.title ||
            ""
          );
        };

        const isCircleTool = tooltip => /círculo|circulo|circle/i.test(String(tooltip || ""));

        const circleIdx = icons.findIndex(img => isCircleTool(getTooltip(img)));
        if (circleIdx !== -1 && icons[circleIdx + 1]) {
          const next = icons[circleIdx + 1];
          const nextTooltip = getTooltip(next);
          if (!nextTooltip) {
            next.title = "Orientação (Azimute)";
            if (next.parentElement) next.parentElement.title = "Orientação (Azimute)";
            const li = next.closest?.("li");
            if (li) li.title = "Orientação (Azimute)";
          }

          const effectiveTooltip = getTooltip(next);
          const isAzimuteTool =
            !nextTooltip || /Azimute/i.test(String(effectiveTooltip || "")) || /orienta/i.test(String(effectiveTooltip || ""));
          if (isAzimuteTool && next && typeof next.src === "string") {
            next.src = COMPASS_ROSE_SVG_DATA_URL;
          }
        }

        icons.forEach(img => {
          if (img.parentElement?.classList?.contains("v4d-tool-wrap")) return;
          const wrap = document.createElement("div");
          wrap.className = "v4d-tool-wrap";
          const tooltip = getTooltip(img);
          if (tooltip) wrap.setAttribute("data-tooltip", tooltip);
          img.parentNode.insertBefore(wrap, img);
          wrap.appendChild(img);
        });

        // Ajustes visuais extras em tools do Potree (troca de ícones por SVG)
        icons.forEach(img => {
          const tooltip = getTooltip(img);
          const n = normalizeToolText(tooltip);

          if (/remover|limpar/.test(n) && /medic/.test(n)) {
            if (img && typeof img.src === "string") img.src = TRASH_SVG_DATA_URL;
          }
        });
      });
    });

    if (metadataUrl) {
      fetch(metadataUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Erro HTTP! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(metadata => {
          const name = metadata.name;
          viewer.setDescription(name);

          window.Potree.loadPointCloud(metadataUrl, name, e => {
            let scene = viewer.scene;
            let pointcloud = e.pointcloud;
            let material = pointcloud.material;
            material.size = 1;
            material.pointSizeType = window.Potree.PointSizeType.ADAPTIVE;
            material.shape = window.Potree.PointShape.SQUARE;

            scene.addPointCloud(pointcloud);
            viewer.fitToScreen();
          });
        })
        .catch(error => {
          console.error("Falha ao carregar metadata do ponto de nuvem:", error);
        });
    }
  }, [metadataUrl]);

  return (
    <div
      className="potree-wrapper"
      style={{
        position: "absolute",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        zIndex: "10",
        width: "100%",
        height: "100%"
      }}
    >
      <div
        id="potree_render_area"
        style={{
          position: "relative",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          width: "100%",
          height: "100%",
          overflow: "hidden"
        }}
      ></div>

      {/* SIDEBAR */}
      <div id="potree_sidebar_container"></div>
    </div>
  );
}

export default PotreePointcloudShared;
